import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { ResponsiveLine } from "@nivo/line";
import { Card } from "../../../components/Card";
import { numberFormatter } from "../../../utils";

function Chart({ data = [], legends, ...rest }) {
  const chartTextColor = useColorModeValue("black", "white");
  const chartBgColor = useColorModeValue("white", "black");
  const chartGridColor = useColorModeValue("gainsboro", "slategrey");

  // Adding width 99% to fix issue https://github.com/plouc/nivo/issues/411
  // Implemented this solution https://github.com/plouc/nivo/issues/411#issuecomment-761939245
  return (
    <Box blockSize="60" inlineSize="99%" {...rest}>
      <ResponsiveLine
        data={data}
        colors={{ scheme: "set1" }}
        margin={{ top: 10, right: 20, bottom: 80, left: 50 }}

        sliceTooltip={point => {
          return (
            <Card p={3}>
              {
                point?.slice?.points?.map((item, itemIndex) => {
                  return (<Flex key={itemIndex} gap={3}>
                    <Box bg={item?.serieColor} width={3} height={3} marginBlockStart={1.5}/>
                    <Text fontWeight="bold">{item?.serieId}</Text>
                    <Text>£{item?.data?.yFormatted}</Text>
                    <Text>(£{Math.round(item?.data?.carbonPrice) ?? "n/a"}C),</Text>
                    <Text>{Math.round(item?.data?.co2emission).toLocaleString('en-GB', { maximumFractionDigits: 0 }) ?? "n/a"} tCO<sub>2e</sub></Text>
                  </Flex>);
                })
              }
              <Text fontSize="sm" fontStyle="italic">Note: C stands for Carbon Price</Text>
            </Card>);
        }}

        yScale={{
          type: "linear",
          min: "auto",
          max: "auto",
          stacked: false,
          reverse: false
        }}
        yFormat={value => numberFormatter(value, 0)}

        axisBottom={{
          orient: "bottom",
          tickSize: 2,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Year",
          legendOffset: 36,
          legendPosition: "middle"
        }}
        pointBorderWidth={2}
        pointLabelYOffset={-12}
        axisLeft={{
          orient: "left",
          tickSize: 2,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Cost of Carbon (£m)",
          legendOffset: -43,
          legendPosition: "middle",
          format: value => numberFormatter(value, 0)
        }}
        enableGridY={false}
        enableSlices="x"
        useMesh
        theme={{
          textColor: chartTextColor,
          grid: {
            line: {
              stroke: chartGridColor
            }
          },
          tooltip: {
            container: {
              background: chartBgColor,
              color: chartTextColor
            }
          }
        }}
        legends={legends}
      />
    </Box>
  );
}

export default Chart;
